"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "svgRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Icon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Icon, _React$PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          svgRef = _this$props.svgRef,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: (0, _classnames.default)('ui-icon', className),
        ref: svgRef
      }, otherProps), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.533 6c6.475 0 9.404 6.1 9.433 6.166l.1.218-.107.216c-.031.062-3.201 6.149-9.426 6.149S2.139 12.662 2.108 12.6L2 12.383l.1-.217C2.13 12.1 5.059 6 11.533 6zm0 11.75c4.991 0 7.803-4.329 8.413-5.383C19.374 11.313 16.713 7 11.533 7s-7.84 4.313-8.412 5.367c.612 1.054 3.422 5.383 8.412 5.383zm3.303-3.627l6.357 4.238-.554.832-6.384-4.256a3.743 3.743 0 0 1-6.143-4.095L1.806 6.639l.554-.832L8.64 9.992a3.743 3.743 0 0 1 6.197 4.131zm-5.877-2.716a2.742 2.742 0 0 0 4.448 2.965l-4.448-2.965zm.519-.856l4.52 3.014a2.743 2.743 0 0 0-4.521-3.014z"
      }));
    }
  }]);
  return Icon;
}(_react.default.PureComponent);

Icon.displayName = 'EyeSlashIcon';
var _default = Icon;
exports.default = _default;
//# sourceMappingURL=EyeSlash.js.map